import { Document as DocumentType } from '@/payload/payload-types';

const getSubTopicContent = (
	serializedObject: DocumentType['documentContent'],
	commentText: string | undefined,
) => {
	// Ensure serializedObject has a root with children
	if (
		!serializedObject ||
		!serializedObject.root ||
		!Array.isArray(serializedObject.root.children)
	) {
		throw new Error('Invalid serialized object');
	}

	const root = serializedObject.root;
	const commentNode = {
		detail: 0,
		format: 0,
		mode: 'normal',
		style: '',
		text: commentText,
		type: 'comment',
		version: 1,
	};

	// Get the last block
	const lastBlock = root.children[root.children.length - 1];

	if (lastBlock && Array.isArray(lastBlock.children)) {
		// Check if the comment is already present
		const isCommentAdded = lastBlock.children.some(child => child.text === commentText);

		if (!isCommentAdded) {
			lastBlock.children.push(commentNode);
		}
	} else {
		// If no blocks are present or last block has no children, create a new paragraph block
		const newParagraphNode = {
			children: [commentNode],
			direction: 'ltr',
			format: '',
			indent: 0,
			type: 'paragraph',
			version: 1,
		};
		root.children.push(newParagraphNode);
	}

	return serializedObject;
};

export default getSubTopicContent;
